import { useRouter } from 'next/router';
import { Callout, Stack } from '@global-ecom/nitro-uds/elements';

import { Variant } from '__generated__/graphql';
import { useSiteConfig } from 'hooks/useSiteConfig';
import { useTranslate } from 'hooks/useTranslations';
import { hasVariantFreeShipping } from 'utils/hasVariantFreeShipping';
import { getReturnsMessage, RETURN_RULE_ID } from 'utils/getReturnsMessage';

type ShippingReturnsMessageProps = {
  variation?: Variant | null;
  freeShippingThreshold?: number | null;
  returnsDisabled?: boolean | null;
};

export const ShippingReturnsMessages = ({
  variation,
  freeShippingThreshold,
  returnsDisabled,
}: ShippingReturnsMessageProps) => {
  const translate = useTranslate();
  const router = useRouter();

  const thresholdDateToCheck = router.query.viewAt
    ? new Date(parseInt(router.query.viewAt as string))
    : new Date();

  const { scheduledFreeShippingThresholds } = useSiteConfig();
  const showFreeShippingMessage = hasVariantFreeShipping(
    variation,
    freeShippingThreshold,
    {
      scheduledThresholds: scheduledFreeShippingThresholds,
      dateToCheck: thresholdDateToCheck,
    }
  );

  const showReturnsMessage =
    !returnsDisabled &&
    !variation?.isFinalSale &&
    variation?.returnRuleID !== RETURN_RULE_ID.NON_ELIGIBLE;

  return (
    <Stack gap="xs" className="py-4">
      {showFreeShippingMessage && (
        <Callout
          variant="success"
          content={translate('freeShipping')}
          icon="truck"
          dataTestId="pdp-shipping-message"
        />
      )}

      {showReturnsMessage && (
        <Callout
          variant="muted"
          content={getReturnsMessage(
            translate,
            variation?.returnRuleID as RETURN_RULE_ID
          )}
          icon="loop-forward"
          dataTestId="pdp-return-message"
        />
      )}
    </Stack>
  );
};
